/**
 * AI-5t9p (2026-08-04) — web mirror of mobile `core/util/source_display.dart`.
 *
 * `walkin` (no hyphen) is the FIELD-CAPTURE token written by the mobile field
 * lead wizard; `walk-in` (hyphenated) is the genuine walk-in written by the
 * triage-create enum (lead-capture.routes.ts:2074) and offered by the web
 * triage dashboard. They are disjoint populations — keep them so.
 *
 * Token space is FREE-TEXT (the backend emits sourceName verbatim — production
 * holds `Panipat Field Import`, `Refrence Aakash`, `-`), so the default branch
 * echoes the raw token rather than swallowing it: an unmapped source reads
 * slightly rough instead of silently vanishing from the UI.
 *
 * Case is normalised first, because production stores the same source in
 * several casings (`WEBSITE` + `Website`, `INDIAMART` + `Indiamart`).
 */
const LABELS: Record<string, string> = {
  manual: 'Mobile app',
  manak_demo_seed: 'Mobile app',
  indiamart: 'IndiaMART',
  tradeindia: 'TradeIndia',
  website: 'Website',
  walkin: 'Field lead',
  'walk-in': 'Walk-in',
  reference: 'Reference',
  referral: 'Reference',
  social: 'Social',
  social_media: 'Social',
  inbound: 'Inbound call',
  inbound_call: 'Inbound call',
  'ai chatbox': 'WhatsApp',
  ai_chatbox: 'WhatsApp',
  whatsapp: 'WhatsApp',
  email: 'Email',
  automation: 'Automation',
  'online campaign': 'Online campaign',
  'phone-in': 'Phone-in',
  'direct call': 'Direct call',
  csv_import: 'CSV import',
  stellar_sanitar: 'Stellar Sanitar',
  unknown: 'Unknown source',
};

export function sourceDisplayLabel(token: string | null | undefined): string {
  const raw = (token ?? '').trim();
  if (raw === '') return 'Unknown source';
  return LABELS[raw.toLowerCase()] ?? raw;
}

/**
 * T6 — the fixed 7-key source-filter enum (spec §3), mirrored 1:1 from
 * backend/src/modules/leads/source-mapping.ts's `LEAD_SOURCE_KEYS`. This is
 * the vocabulary the shared leads-list endpoint's `?source=` CSV param
 * accepts — NOT the raw free-text `sourceName` values `sourceDisplayLabel`
 * above handles (those still label the per-row Source badge unchanged).
 */
export const LEAD_SOURCE_KEYS = [
  'whatsapp_chatkart',
  'indiamart',
  'manual',
  'import',
  'field',
  'other',
  'none',
] as const;

export type LeadSourceKey = (typeof LEAD_SOURCE_KEYS)[number];

export const LEAD_SOURCE_KEY_LABELS: Record<LeadSourceKey, string> = {
  whatsapp_chatkart: 'WhatsApp',
  indiamart: 'IndiaMART',
  manual: 'Manual / Mobile',
  import: 'CSV Import',
  field: 'Field',
  other: 'Other',
  none: 'None',
};
